import React from 'react';
import { Group, Circle, Rect } from 'react-konva';
import type { EquipmentPoint } from '../../features/equipment/equipmentTypes';

type Props = {
  points: EquipmentPoint[];
  cursor: EquipmentPoint | null;
  zoom: number;
};

const ACCENT = '#2563eb';

/**
 * Live preview of the rectangular footprint from its first corner to the cursor.
 */
const EquipmentDrawOverlay: React.FC<Props> = ({ points, cursor, zoom }) => {
  if (points.length === 0 && !cursor) return null;

  if (points.length === 0 || !cursor) {
    return cursor ? (
      <Circle x={cursor.x} y={cursor.y} radius={3 / zoom} fill={ACCENT} listening={false} />
    ) : null;
  }
  const a = points[0];
  const x = Math.min(a.x, cursor.x);
  const y = Math.min(a.y, cursor.y);
  const w = Math.abs(cursor.x - a.x);
  const h = Math.abs(cursor.y - a.y);
  return (
    <Group listening={false}>
      <Rect
        x={x}
        y={y}
        width={w}
        height={h}
        fill="rgba(37, 99, 235, 0.12)"
        stroke={ACCENT}
        strokeWidth={1.5 / zoom}
        dash={[6 / zoom, 4 / zoom]}
      />
    </Group>
  );
};

export default EquipmentDrawOverlay;
